import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['clearButton', 'input'];

  toggleClearButton(event) {
    this.clearButtonTarget.classList.toggle('hidden', event.target.value === '');
  }

  clear() {
    this.inputTarget.value = '';
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.inputTarget.focus();
    this.dispatch('clear', { bubbles: true });
  }
}
